import {
  IconCircleLetterB,
  IconDeviceDesktopAnalytics,
  IconFileAnalytics,
  IconLayoutBoard,
  IconLayoutBoardSplit,
  IconShieldLock,
  IconUserCircle,
  IconUserQuestion,
  IconUsers as IconUsersGlyph,
  type IconProps,
} from "@tabler/icons-react";

import { ProfileOverview } from "../pages/profile/ProfileOverview";
import { ProfileMe } from "../pages/profile/ProfileMe";
import { ProfileUsers } from "../pages/profile/ProfileUsers";
import { ProfileRequests } from "../pages/profile/ProfileRequests";
import { ProfileEntitlements } from "../pages/profile/ProfileEntitlements";
import { ProfileSso } from "../pages/profile/ProfileSso";
import type { ComponentType } from "react";

export type ProfileNavItem = {
  label: string;
  segment: string;
  group?: string;
  Element: ComponentType;
  Icon?: ComponentType<IconProps>;
  /** Reads organisation-scoped data — the API refuses these for a plain member. */
  orgAdminOnly?: boolean;
  /** Which live count the sidebar shows beside the label. */
  countOf?: "openRequests";
};

export const PROFILE_URL = "/profile";
export const ADD_TOKENS_HASH = "#add-tokens";

export const profilePath = (segment: string) => `${PROFILE_URL}/${segment}`;

export const IconOverview = IconLayoutBoardSplit;
export const IconMyAccount = IconUserCircle;
export const IconUsers = IconUsersGlyph;
export const IconRequests = IconUserQuestion;
export const IconEntitlements = IconLayoutBoard;
export const IconSso = IconShieldLock;
export const IconAuditLog = IconFileAnalytics;
export const IconBalance = IconCircleLetterB;
export const IconStatement = IconDeviceDesktopAnalytics;

export const GENERAL_NAVS: ProfileNavItem[] = [
  {
    label: "Overview",
    segment: "overview",
    Element: ProfileOverview,
    Icon: IconOverview,
    orgAdminOnly: true,
  },
  {
    label: "My account",
    segment: "me",
    Element: ProfileMe,
    Icon: IconMyAccount,
  },
];
export const IDENTITY_NAVS: ProfileNavItem[] = [
  {
    label: "Users",
    segment: "users",
    orgAdminOnly: true,
    Element: ProfileUsers,
    Icon: IconUsers,
  },
  {
    label: "Requests",
    segment: "requests",
    orgAdminOnly: true,
    Element: ProfileRequests,
    Icon: IconRequests,
    countOf: "openRequests",
  },
  {
    label: "Entitlements",
    segment: "entitlements",
    orgAdminOnly: true,
    Element: ProfileEntitlements,
    Icon: IconEntitlements,
  },
  {
    label: "Single sign-on",
    segment: "sso",
    orgAdminOnly: true,
    Element: ProfileSso,
    Icon: IconSso,
  },
];

// The audit-log tab and the Tokens group (Balance, Statement) were dropped for launch —
// nothing behind them is wired up yet. Their page components stay in the tree; restore
// their nav entries here when the features exist.
export const PROFILE_NAV_ITEMS: ProfileNavItem[] = [
  ...GENERAL_NAVS,
  ...IDENTITY_NAVS,
];

export const DEFAULT_PROFILE_PATH = profilePath(PROFILE_NAV_ITEMS[0].segment);

// Every user has a personal account page, admin or not — the one profile destination
// that never depends on an org-admin permission.
export const PROFILE_ME_PATH = profilePath("me");
